export default function Marquee({ items, className = "" }) {
  const list = [...items, ...items];
  return (
    <div className={`marquee relative overflow-hidden ${className}`} data-testid="marquee">
      <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-white to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-white to-transparent z-10" />
      <ul className="marquee-track">
        {list.map((t, i) => (
          <li
            key={`${t}-${i}`}
            aria-hidden={i >= items.length ? "true" : undefined}
            className="flex items-center gap-10 pr-10 font-display text-xl md:text-2xl text-[var(--ink)]/80 whitespace-nowrap"
            data-testid={i < items.length ? "insurance-chip" : undefined}
          >
            {t}
            <span className="h-1.5 w-1.5 rounded-full bg-[#5D6F59]/50" />
          </li>
        ))}
      </ul>
    </div>
  );
}
